import { LoDashImplicitNumberArrayWrapper } from "lodash";
import { RptNhanVeParamsType } from "../../restapi/tongHopReport";
import { globalDexieDb } from "../DexiedbLib";
import { DetailsData } from "../model/detailsDataReport";
import { IMessageDetail } from "../model/messageDetails";
import { MessageReport, MessageReportImpl } from "./totalReport";
import { DEBUG } from "../../../../config";
import { GetUserID } from "../../utils/common";

export async function FetchContactReportAllInOneLocal(payload: any): Promise<any> {
    const ret: MessageReport[] = [];
    const { messageId, mienDaiCuocId, ngay, contactId } = payload;


    const messageReport = new MessageReportImpl();
    const param = { messageId, mienDaiCuocId: Number(mienDaiCuocId), ngay, contactId }
    const rpt = await messageReport.buildReport(param)
    ret.push(rpt);

    // lấy báo cáo tổng của từng tin, thêm vào ret
    const messages = await globalDexieDb.dbmessages.where("[date+contactId]").equals([ngay, contactId]).toArray()

    for (let message of messages) {
        const param = {
            messageId: message.messageId!,
            mienDaiCuocId: Number(mienDaiCuocId),
            ngay, contactId
        }
        const messageReport = new MessageReportImpl();
        const rpt = await messageReport.buildReport(param)
        if (rpt.children.length > 0)
            ret.push(rpt);
    }

    const result = {
        responseText: "",
        errorCode: 0,
        data: ret,
        dataEx: null
    }
    return result;
}

export async function FetchContactReport3MienLocal(payload: any): Promise<any> {
    const ret: MessageReport[] = [];
    const { messageId, mienDaiCuocId, ngay, contactId } = payload;
    for (let i = 1; i <= 3; i++) {
        const param = { messageId, mienDaiCuocId: i, ngay, contactId }
        const messageReport = new MessageReportImpl();
        const rpt = await messageReport.buildReport(param)
        rpt.key = i;
        ret.push(rpt);
    }
    const result = {
        responseText: "",
        errorCode: 0,
        data: ret,
        dataEx: null
    }
    return result;
}
/**
 * const { contactId, mienDaiCuocId, ngay } = payload;
*/
export async function FetchDetailsReportByContactIDLocal(payload: any): Promise<any> {
    const { contactId, mienDaiCuocId, ngay } = payload;
    const messages = await globalDexieDb.dbmessages.where("[date+contactId]").equals([ngay, contactId]).toArray()

    const ret: DetailsData[] = []
    const map: Map<string, DetailsData> = new Map()
    for (let message of messages) {
        const curMsgData = await globalDexieDb.messageDetails.where("messageId").equals(message.messageId!).toArray()
        for (let dataRow of curMsgData) {
            const key = `${dataRow.daiId1}-${dataRow.daiId2}-${dataRow.loaiCuocId}-${dataRow.soCuoc}`
            let found = map.get(key)
            const quaCo = dataRow.diem! * dataRow.gia! * dataRow.soGiai! * dataRow.heSoNhan
            const thuong = (dataRow.soNhayTrung > 0 ? dataRow.diem! * dataRow.hsThuong * dataRow.soNhayTrung : 0) * dataRow.heSoNhan
            const trung = dataRow.diem! * dataRow.soNhayTrung * dataRow.heSoNhan
            const xac = dataRow.diem! * dataRow.soGiai! * dataRow.heSoNhan
            if (found) {
                found.quaCo += quaCo
                found.thuong += thuong
                found.trung += 0;//trung
                found.diem += dataRow.diem!
            } else {
                found = {
                    daiId1: dataRow.daiId1!,
                    daiId2: dataRow.daiId2!,
                    loaiCuocId: dataRow.loaiCuocId,
                    soCuoc: dataRow.soCuoc,
                    diem: dataRow.diem!,
                    quaCo: quaCo,
                    trung: dataRow.soNhayTrung,
                    thuong: thuong,
                }
                map.set(key, found)
            }
        }
    }
    for (let [key, value] of map) {
        ret.push(value)
    }
    ret.sort((a, b) => {
        if (a.trung > b.trung) return -1
        if (a.trung < b.trung) return 1
        if (a.daiId1 > b.daiId1) return 1
        if (a.daiId2 > b.daiId2) return 1
        if (a.loaiCuocId > b.loaiCuocId) return 1
        if (a.diem < b.diem) return 1
        if (a.soCuoc > b.soCuoc) return 1

        return 0
    })
    const result = {
        responseText: "",
        errorCode: 0,
        data: ret,
        dataEx: null
    }
    return result;
}
/***
 * 
 * @param payload 
 * const { messageId, mienDaiCuocId } = payload;
 */
export async function FetchDetailsReportByMessageIDLocal(payload: any): Promise<any> {
    const { messageId, mienDaiCuocId } = payload;


    const ret: DetailsData[] = []
    const map: Map<string, DetailsData> = new Map()

    const curMsgData = await globalDexieDb.messageDetails.where("[messageId+mienDaiCuocId]").equals([messageId, mienDaiCuocId]).toArray()
    for (let dataRow of curMsgData) {
        const key = `${dataRow.daiId1}-${dataRow.daiId2}-${dataRow.loaiCuocId}-${dataRow.soCuoc}`
        let found = map.get(key)
        const quaCo = dataRow.diem! * dataRow.gia! * dataRow.soGiai! * dataRow.heSoNhan
        const thuong = (dataRow.soNhayTrung > 0 ? dataRow.diem! * dataRow.hsThuong * dataRow.soNhayTrung : 0) * dataRow.heSoNhan
        const trung = dataRow.diem! * dataRow.soNhayTrung * dataRow.heSoNhan
        const xac = dataRow.diem! * dataRow.soGiai! * dataRow.heSoNhan
        if (found) {
            found.quaCo += quaCo
            found.thuong += thuong
            found.trung += 0;//trung
            found.diem += dataRow.diem!
        } else {
            found = {
                daiId1: dataRow.daiId1!,
                daiId2: dataRow.daiId2!,
                loaiCuocId: dataRow.loaiCuocId,
                soCuoc: dataRow.soCuoc,
                diem: dataRow.diem!,
                quaCo: quaCo,
                trung: dataRow.soNhayTrung,
                thuong: thuong,
            }
            map.set(key, found)
        }
    }

    for (let [key, value] of map) {
        ret.push(value)
    }
    ret.sort((a, b) => {
        if (a.trung > b.trung) return -1
        if (a.trung < b.trung) return 1
        if (a.daiId1 > b.daiId1) return 1
        if (a.daiId2 > b.daiId2) return 1
        if (a.loaiCuocId > b.loaiCuocId) return 1
        if (a.diem < b.diem) return 1
        if (a.soCuoc > b.soCuoc) return 1

        return 0
    })
    const result = {
        responseText: "",
        errorCode: 0,
        data: ret,
        dataEx: null
    }
    return result;
}
export interface ApiResult {
    responseText: string;
    errorCode: number;
    data: any,
    dataEx: any,
}
export interface ContactExtraInfo {
    contactId: number,
    allCount: number,
    mbCount: number,
    mtCount: number,
    mnCount: number,
    mbCountIn: number,
    mtCountIn: number,
    mnCountIn: number,
    mbCountOut: number,
    mtCountOut: number,
    mnCountOut: number,
}
export interface DetailsDataRpt {
    daiId1: string,
    daiId2: string,
    loaiCuocId: string,
    soCuoc: string,
    sumDiem: number,
    trung: number,
}
/**
 * const { ngay } = payload
*/
export async function getContactsListExtraInfoLocal(payload: any): Promise<ApiResult> {
    const { ngay } = payload

    const ret: ApiResult = {
        responseText: "",
        errorCode: 0,
        data: [],
        dataEx: null,
    }
    //
    const msgs = await globalDexieDb.dbmessages.where("date").equals(ngay).toArray()
    const map: Map<number, ContactExtraInfo> = new Map()
    for (let msg of msgs) {
        const key = msg.contactId
        let found = map.get(key)
        if (!found) {
            found = {
                contactId: msg.contactId,
                allCount: 0,
                mbCount: 0,
                mtCount: 0,
                mnCount: 0,
            }
            map.set(key, found)
        }
        if (await isFoundDataInMien(msg.messageId!, 1)) {
            found.mbCount++
        }
        if (await isFoundDataInMien(msg.messageId!, 2)) {
            found.mtCount++
        }
        if (await isFoundDataInMien(msg.messageId!, 3)) {
            found.mnCount++
        }
    }
    const infos: ContactExtraInfo[] = []
    for (let [key, value] of map) {
        value.allCount = value.mbCount + value.mtCount + value.mnCount
        infos.push(value)
    }
    ret.data = infos;
    return ret;
}
export async function isFoundDataInMien(messageId: number, mienDaiCuocId: number) {
    const found = await globalDexieDb.messageDetails.where("[messageId+mienDaiCuocId]").equals([messageId, mienDaiCuocId]).first()
    if (found) return true;
    return false;
}
export async function deleteMessageLocal(messageId: number): Promise<any> {
    await globalDexieDb.dbmessages.where("messageId").equals(messageId).delete()
    await globalDexieDb.messageDetails.where("messageId").equals(messageId).delete()
    return;
}
export async function FetchNhanVeLocal(payload: RptNhanVeParamsType): Promise<ApiResult> {
    const { contactId, daiIds, ngay, mienDaiCuocId, loaiCuocIds } = payload;
    const ret: ApiResult = {
        responseText: "",
        errorCode: 0,
        data: null,
        dataEx: null
    }
    const datas: IMessageDetail[] = []
    const userId = Number(GetUserID())
    let messages;
    if (contactId > 0)
        messages = await globalDexieDb.dbmessages.where("[date+contactId]").equals([ngay, contactId]).toArray()
    else
        messages = await globalDexieDb.dbmessages.where("[date+userId]").equals([ngay, userId]).toArray()
    for (let msg of messages) {
        const tmp = await globalDexieDb.messageDetails.where("[messageId+mienDaiCuocId]").equals([msg.messageId!, mienDaiCuocId])
            .and(function (item) {
                const ok = (daiIds.includes(item.daiId1!) || daiIds.includes(item.daiId2!))
                    && loaiCuocIds.includes(item.loaiCuocId!) && item.heSoNhan == 1;

                return ok;
            }).toArray()
        datas.push(...tmp)
    }
    const dataReport: DetailsDataRpt[] = []
    const map: Map<string, DetailsDataRpt> = new Map()
    for (let item of datas) {
        buildNhanGiuChuyenData(item, map)
    }
    for (let [key, value] of map) {
        dataReport.push(value)
    }
    dataReport.sort((a, b) => {
        if (a.daiId1 > b.daiId1) return 1
        if (a.daiId2 > b.daiId2) return 1

        if (a.loaiCuocId > b.loaiCuocId) return 1
        if (a.loaiCuocId < b.loaiCuocId) return -1

        if (a.sumDiem > b.sumDiem) return -1
        if (a.sumDiem < b.sumDiem) return 1

        if (a.soCuoc > b.soCuoc) return 1
        if (a.soCuoc < b.soCuoc) return -1

        return 0



    })

    ret.data = dataReport;
    if (DEBUG)
        console.log('dataReport length=', dataReport.length)
    return ret;
}
export async function FetchGiuLaiLocal(payload: RptNhanVeParamsType): Promise<ApiResult> {
    const { contactId, daiIds, ngay, mienDaiCuocId, loaiCuocIds } = payload;
    const ret: ApiResult = {
        responseText: "",
        errorCode: 0,
        data: null,
        dataEx: null
    }
    const datas: IMessageDetail[] = []
    const userId = Number(GetUserID())
    let messages;
    if (contactId > 0)
        messages = await globalDexieDb.dbmessages.where("[date+contactId]").equals([ngay, contactId]).toArray()
    else
        messages = await globalDexieDb.dbmessages.where("[date+userId]").equals([ngay, userId]).toArray()
    for (let msg of messages) {
        const tmp = await globalDexieDb.messageDetails.where("[messageId+mienDaiCuocId]").equals([msg.messageId!, mienDaiCuocId])
            .and(function (item) {
                const ok = (daiIds.includes(item.daiId1!) || daiIds.includes(item.daiId2!))
                    && loaiCuocIds.includes(item.loaiCuocId!) /* && item.heSoNhan == 1 */;

                return ok;
            }).toArray()
        datas.push(...tmp)
    }
    const dataReport: DetailsDataRpt[] = []
    const map: Map<string, DetailsDataRpt> = new Map()
    for (let item of datas) {
        buildNhanGiuChuyenData(item, map)
    }
    for (let [key, value] of map) {
        dataReport.push(value)
    }
    dataReport.sort((a, b) => {
        if (a.daiId1 != b.daiId1) {
            if (a.daiId1 > b.daiId1) return 1
            if (a.daiId1 < b.daiId1) return -1
        }
        if (a.daiId2 != b.daiId2) {
            if (a.daiId2 > b.daiId2) return 1
            if (a.daiId2 < b.daiId2) return -1
        }

        if (a.loaiCuocId != b.loaiCuocId) {
            if (a.loaiCuocId > b.loaiCuocId) return 1
            if (a.loaiCuocId < b.loaiCuocId) return -1
        }
        if (a.sumDiem != b.sumDiem) {
            if (a.sumDiem > b.sumDiem) return -1
            if (a.sumDiem < b.sumDiem) return 1
        }
        if (a.soCuoc != b.soCuoc) {
            if (a.soCuoc > b.soCuoc) return 1
            if (a.soCuoc < b.soCuoc) return -1
        }
        return 0

    })
    if (DEBUG)
        console.log('dataReport length=', dataReport.length)
    ret.data = dataReport;
    return ret;
}
export async function FetchChuyenDiLocal(payload: RptNhanVeParamsType): Promise<ApiResult> {
    const { contactId, daiIds, ngay, mienDaiCuocId, loaiCuocIds } = payload;
    const ret: ApiResult = {
        responseText: "",
        errorCode: 0,
        data: null,
        dataEx: null
    }
    const datas: IMessageDetail[] = []
    const userId = Number(GetUserID())
    let messages;
    if (contactId > 0)
        messages = await globalDexieDb.dbmessages.where("[date+contactId]").equals([ngay, contactId]).toArray()
    else
        messages = await globalDexieDb.dbmessages.where("[date+userId]").equals([ngay, userId]).toArray()
    for (let msg of messages) {
        const tmp = await globalDexieDb.messageDetails.where("[messageId+mienDaiCuocId]").equals([msg.messageId!, mienDaiCuocId])
            .and(function (item) {
                const ok = (daiIds.includes(item.daiId1!) || daiIds.includes(item.daiId2!))
                    && loaiCuocIds.includes(item.loaiCuocId!) && item.heSoNhan == -1;

                return ok;
            }).toArray()
        datas.push(...tmp)
    }
    const dataReport: DetailsDataRpt[] = []
    const map: Map<string, DetailsDataRpt> = new Map()
    for (let item of datas) {
        buildNhanGiuChuyenData(item, map)
    }
    for (let [key, value] of map) {
        value.sumDiem = -value.sumDiem;// đổi dấu thành dương
        dataReport.push(value)
    }
    dataReport.sort((a, b) => {
        if (a.daiId1 > b.daiId1) return 1
        if (a.daiId2 > b.daiId2) return 1

        if (a.loaiCuocId > b.loaiCuocId) return 1
        if (a.loaiCuocId < b.loaiCuocId) return -1

        if (a.sumDiem > b.sumDiem) return -1
        if (a.sumDiem < b.sumDiem) return 1

        if (a.soCuoc > b.soCuoc) return 1
        if (a.soCuoc < b.soCuoc) return -1
        return 0

    })

    ret.data = dataReport;
    if (DEBUG)
        console.log('dataReport length=', dataReport.length)
    return ret;
}
// cộng vào hoặc trừ đi số điểm của 1 số cược cụ thể
async function buildNhanGiuChuyenData(item: IMessageDetail, map: Map<string, DetailsDataRpt>) {
    const key = `${item.daiId1}-${item.daiId2}-${item.loaiCuocId}-${item.soCuoc}`
    let found: DetailsDataRpt | undefined = map.get(key)
    if (!found) {
        if (item.heSoNhan > 0) {
            found = {
                daiId1: item.daiId1!,
                daiId2: item.daiId2!,
                loaiCuocId: item.loaiCuocId!,
                soCuoc: item.soCuoc!,
                sumDiem: item.diem!,
                trung: item.soNhayTrung!,
            }
        }
        else {
            found = {
                daiId1: item.daiId1!,
                daiId2: item.daiId2!,
                loaiCuocId: item.loaiCuocId!,
                soCuoc: item.soCuoc!,
                sumDiem: -item.diem!,
                trung: item.soNhayTrung!,
            }
        }
        map.set(key, found)
    } else {
        if (item.heSoNhan > 0)
            found.sumDiem += item.diem!
        else
            found.sumDiem -= item.diem!
    }
}